import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";


i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;